import React, { Fragment } from 'react';
import { Button, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import {
    getActionVisual,
    getActionVisualStyle,
} from 'src/modules/assistant/helpers/actionVisuals';
import { TRecommendationOption } from 'src/modules/assistant/types/message';
import { useNextBestActionCardStyles } from './styles';

const ICON_SIZE = 15;
const RECOMMENDED_INDEX = 0;
const FIRST_ALTERNATIVE_INDEX = 1;

interface RecommendationOptionsProps {
    options: TRecommendationOption[];
    channel?: string | null;
    onSelect: (intent: string) => void;
}

/**
 * Buttons for the options of a recommendation: the first one is the recommended
 * option and the rest are grouped as alternatives.
 */
export const RecommendationOptions = ({
    options,
    channel,
    onSelect,
}: RecommendationOptionsProps) => {
    const classes = useNextBestActionCardStyles();
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <>
            {options.map(({ intent, label, labelParams }, index) => {
                const visual = getActionVisual(intent, channel);
                const { Icon } = visual;
                const recommended = index === RECOMMENDED_INDEX;
                return (
                    <Fragment key={intent}>
                        {(recommended || index === FIRST_ALTERNATIVE_INDEX) && (
                            <Typography
                                className={classes.groupLabel}
                                color="textSecondary"
                                variant="overline"
                            >
                                {t(
                                    recommended
                                        ? 'Assistant.Recommended'
                                        : 'Assistant.OtherOptions'
                                )}
                            </Typography>
                        )}
                        <Button
                            className={
                                recommended
                                    ? classes.option
                                    : classes.alternative
                            }
                            onClick={() => onSelect(intent)}
                            size="small"
                            startIcon={
                                <Icon
                                    aria-hidden="true"
                                    height={ICON_SIZE}
                                    width={ICON_SIZE}
                                />
                            }
                            style={getActionVisualStyle(visual, theme)}
                            variant={recommended ? 'contained' : 'outlined'}
                        >
                            {t(label, labelParams)}
                        </Button>
                    </Fragment>
                );
            })}
        </>
    );
};
